import React, { useState } from 'react';
import styled from 'styled-components';

import IconComponent from '../../../../components/icon/icon';
import { Quiz } from '../../types';
import MockExamModal from '../mock-exam-modal';

const Card = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--gray-90);
  border-radius: 8px;
  min-height: 351px;

  @media (max-width: 640px) {
    min-height: auto;
  }
`;

const Title = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 24px;
  line-height: 28.8px;
  font-weight: 700;
  letter-spacing: -0.4px;
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 19.6px;
  margin-top: 8px;
`;

const DetailsButton = styled.button`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  line-height: 24px;
  border-top: 1px solid var(--dark-gray-line);
  padding: 16px 24px;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  height: 100%;

  @media (max-width: 640px) {
    gap: 24px;
  }
`;

const ScoreLabel = styled.p`
  font-size: 18px;
  line-height: 19px;
`;

const Score = styled.p`
  font-size: 80px;
  line-height: 1;
  font-weight: 700;

  span {
    display: inline-block;
    font-size: 16px;
    font-weight: normal;
    transform: translateY(-5px);
  }
`;

const TagWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
    color: var(--white);
    background-color: var(--gray-02);
    padding: 0 8px;
    border-radius: 4px;
  }
`;

type Props = Quiz;

const TestItem: React.FC<Props> = ({ title, description, score, tags, guid, startDate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const testStartDate = new Date(startDate);
  const currentDate = new Date();

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <Card>
      <ContentWrapper>
        <div>
          <TagWrapper>
            {tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </TagWrapper>
          <Title>{title}</Title>
          <Description>
            <span dangerouslySetInnerHTML={{ __html: description }}></span>
          </Description>
        </div>
        {score !== null && (
          <div>
            <ScoreLabel>Sua nota</ScoreLabel>
            <Score>
              {score}
              <span>/10</span>
            </Score>
          </div>
        )}
      </ContentWrapper>
      {currentDate >= testStartDate && (
        <DetailsButton type="button" onClick={handleOpen}>
          Ver detalhes
          <IconComponent name="whiteArrow" />
        </DetailsButton>
      )}
      <MockExamModal guid={guid} onClose={handleClose} isOpen={isOpen} />
    </Card>
  );
};

export default TestItem;
